import { render, staticRenderFns } from "./MailingList.vue?vue&type=template&id=52be51b2&scoped=true"
import script from "./MailingList.vue?vue&type=script&lang=js"
export * from "./MailingList.vue?vue&type=script&lang=js"
import style0 from "./MailingList.vue?vue&type=style&index=0&id=52be51b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be51b2",
  null
  
)

export default component.exports